import type { DocumentBlockDTO } from '@shared/schemas/document-model';

/** Blocs dont le texte s'édite directement dans l'aperçu (`inersio:begin-edit`). */
export function isInlineEditableBlock(
  block: DocumentBlockDTO | null | undefined,
): block is Extract<DocumentBlockDTO, { type: 'callout' | 'heading' | 'paragraph' | 'quote' }> {
  return block?.type === 'paragraph'
    || block?.type === 'heading'
    || block?.type === 'quote'
    || block?.type === 'callout';
}

/** Blocs que « Réécrire › Ce passage » peut viser (contenu rédigé, pas une donnée brute ni un séparateur). */
export function isRewritableBlock(block: DocumentBlockDTO | null | undefined) {
  return Boolean(block) && block?.type !== 'divider' && block?.type !== 'page_break' && block?.type !== 'image';
}
